import { createContext, useMemo } from "react";
import { NumberFormatValues } from "@common/schemas/domains/reportSettings/number-format-setting.schema";
import { AccountingReportFilters } from "./types";

interface Context {
    filters: AccountingReportFilters;
    numberFormat?: NumberFormatValues;
}

export const AccountingReportContext = createContext<Context>({
    filters: {},
});

export function useAccountingReportContextValue(
    filters: AccountingReportFilters,
    numberFormat: NumberFormatValues,
): Context {
    return useMemo(() => ({ filters, numberFormat }), [filters, numberFormat]);
}
